import { EvacResponse } from 'src/typings/kenai/configuration/entity-hierarchy'

export const getSignedOutForEvac = (
  evacTimeStamp?: EvacResponse['responseTimestamp'],
  eventTimeStampOut?: number | 'still on premises'
) => {
  return eventTimeStampOut && eventTimeStampOut !== 'still on premises' ? eventTimeStampOut < evacTimeStamp : false
}
